export default __webpack_public_path__ + "static/media/Purity_and_Industry_LE.f33c3b78.jpg";